import axios from 'axios'
import { useState, useEffect, useRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import useFormFeedbackStore from '../../stores/useFormFeedbackStore'
import useLoadingStore from '../../stores/useLoadingStore'
import ConfigAPI from '../../constant/ConfigAPI'

const useStationDetail = () => {
    const [titleMuxDetail, setTitleMuxDetail] = useState<string>('')
    const [muxData, setMuxData] = useState<MUXType>({})
    const [openMuxDetail, setOpenMuxDetail] = useState(false)
    const [isMobileDevice, setIsMobileDevice] = useState(false)
    const [dataContact, setDataContact] = useState<ContactUsType>({})
    const formFeedbackStore = useFormFeedbackStore()
    const loadingStore = useLoadingStore()
    const history = useHistory()

    const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false)
    const refFeedbackStationData = useRef<StationType>()

    useEffect(() => {
        callServiceContact()
        setIsMobileDevice(/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent))

        return () => {
            resetRefFeedbackForm()
        }
    }, [])

    const resetRefFeedbackForm = useCallback(() => {
        refFeedbackStationData.current = undefined
    }, [])

    const callServiceContact = async () => {
        try {
            //loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/content/contactus`
            const result = await axios.get(url, ConfigAPI)

            if (result.data) {
                setDataContact(result.data)
            }

            return { result }
        } catch (error) {
            return { error }
        } finally {
            //loadingStore.setLoading(false)
        }
    }

    const handleClickMuxDetail = (title: string, data: MUXType) => {
        setTitleMuxDetail(title)
        setMuxData(data)
        setOpenMuxDetail(true)
    }

    const handleCloseMuxDetail = () => {
        setOpenMuxDetail(false)
    }

    const handleClickSuggest = (data?: StationType | null) => {
        if (data) {
            setShowPrivacyPolicy(true)
            refFeedbackStationData.current = data
        }
    }

    const handlerPolicyAccepted = useCallback(() => {
        setShowPrivacyPolicy(false)

        if (refFeedbackStationData.current) {
            const data = refFeedbackStationData.current
            formFeedbackStore.setStationDetail(data)
            history.push(`/verify/${data.station_id}`)
        }
    }, [])

    const handlerPolicyPopupClosed = useCallback(() => {
        resetRefFeedbackForm()
        setShowPrivacyPolicy(false)
    }, [])

    return {
        isMobileDevice,
        muxData,
        dataContact,
        openMuxDetail,
        titleMuxDetail,
        onClickMuxDetail: handleClickMuxDetail,
        onCloseMuxDetail: handleCloseMuxDetail,
        onClickSuggest: handleClickSuggest,
        showPrivacyPolicy,
        handlerPolicyAccepted,
        handlerPolicyPopupClosed,
    }
}

export default useStationDetail
